import { LegendOptions, MetaInfoOptions } from '@sprinklr/stories/hyperspaceWidgets/types';
import { observable } from 'mobx';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import { LegendOptionsImpl } from '../options';

import { HyperSpaceQuadrantMatrixWidgetOptions, QuadrantConfig } from './types';

export class HyperSpaceQuadrantMatrixWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpaceQuadrantMatrixWidgetOptions {
    @observable bubble = {
        opacity: 100,
        radius: {
            min: 10,
            max: 50,
        },
    };
    @observable baseXYChartOptions: HyperSpaceQuadrantMatrixWidgetOptions['baseXYChartOptions'] = {
        grid: {
            enabled: true,
        },
        dataLabels: {
            enabled: false,
            fontSize: 30,
            formats: {
                numberFormat: {
                    decimals: 0,
                    useShortened: true,
                },
                dateFormat: {
                    autoFormat: true,
                    formatString: 'dd MMM',
                },
            },
        },
        xAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
        yAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                //TODO: how should we actually set initial value
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
    };
    @observable zeroFill = true;
    @observable legend: LegendOptions = new LegendOptionsImpl();
    @observable metaInfoOptions: MetaInfoOptions = {
        color: {
            enabled: false,
            type: 'fill',
        },
        image: {
            enabled: false,
        },
    };

    @observable quadrantConfig: QuadrantConfig = {
        separators: {
            enabled: true,
            color: '#4A4A4A',
            size: 1,
            x: 0,
            y: 0,
        },
        labels: {
            enabled: true,
            size: 25,
            topLeft: 'Top Left',
            topRight: 'Top Right',
            bottomLeft: 'Bottom Left',
            bottomRight: 'Bottom Right',
        },
    };
}
